import { render, staticRenderFns } from "./MeshBackground.vue?vue&type=template&id=21ec056c&scoped=true&lang=pug&"
import script from "./MeshBackground.vue?vue&type=script&lang=js&"
export * from "./MeshBackground.vue?vue&type=script&lang=js&"
import style0 from "./MeshBackground.vue?vue&type=style&index=0&id=21ec056c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec056c",
  null
  
)

export default component.exports